import Phaser from "phaser";
import SoundManager from "../sound/SoundManager";
import SoundButton from "../ui/soundButton";
import SceneUtils from "../utils/sceneUtils";
import {setupButtonClick} from "../utils/ui";
import HighscorePanel from "../ui/highscorePanel";
import CreditsPanel from "../ui/creditsPanel";
import MobileInputProvider from "../controller/mobileInputProvider";
import NameInput from "../ui/nameInput";
import LocalStorage from "../utils/localStorage";
import BaseScene from "./baseScene";
import TwoFX from "../fx/twoFX";
import ScrollContainer from "../ui/scrollContainer";

export default class TermsAndPrivacy extends BaseScene
{
    constructor ()
    {
        super('TermsAndPrivacy');
    }

    preload ()
    {
        SoundManager.preloadMenu(this);
        MobileInputProvider.preload(this);
        TwoFX.preload(this);
        this.load.image('background', 'src/assets/img/star_fire.jpg');
        this.load.image('btn_home', 'src/assets/img/home_btn.png');
        SoundButton.preload(this);
    }

    create ()
    {
        super.create();
        SoundManager.addFX("button_click", 0.7);
        SoundManager.addFX("intro", 0.7);
        SoundManager.playMusic("intro", true);
        TwoFX.init(this);
        //TwoFX.emitFlares();
        this.createUI();
        this.scale.on("resize", () => SceneUtils.resize(this));
        SceneUtils.resetThree(this.game.threeScene);
    }

    createUI(){
        const offsetY = 0;

        this.homeBtn =  this.add.image(
            this.game.config.width - 70,
            70,
            "btn_home"
        );

        this.homeBtn.setScale(0.15);

        setupButtonClick(this.homeBtn, () => {
            this.cameras.main.fadeOut(500, 0, 0, 0);
            this.cameras.main.once(Phaser.Cameras.Scene2D.Events.FADE_OUT_COMPLETE, (cam, effect) => {
                SceneUtils.startFullscreen(this);
                this.scene.start('Game');
            })
        })

        this.termsText = this.add.text(this.scale.width / 4, this.scale.height / 8  +offsetY, "Terms",
            {fontSize: 60, align: "center", fill: "#eee" }
        )
        this.termsText.setOrigin(0.5)

        this.privacyText = this.add.text(this.scale.width / 4 * 3, this.scale.height / 8  +offsetY, "Privacy",
            {fontSize: 60, align: "center", fill: "#777" }
        )
        this.privacyText.setOrigin(0.5)

        this.scrollContainerTerms = new ScrollContainer({
            scene: this,
            x: this.game.config.width / 2,
            y: this.game.config.height / 2,
            width: 650,
            height: 1000,
            content: "Terms text",
            scrollMode: 0,
            fontFamily: 'Arial',
            darkColor: 0x555555,
            lightColor: 0xbbbbbb
        })

        this.scrollContainerPrivacy = new ScrollContainer({
            scene: this,
            x: this.game.config.width / 2,
            y: this.game.config.height / 2,
            width: 650,
            height: 1000,
            content: "Privacy Text",
            scrollMode: 0,
            fontFamily: 'Arial',
            darkColor: 0x555555,
            lightColor: 0xbbbbbb
        })

        this.scrollContainerPrivacy.visible = false;

        setupButtonClick(this.termsText, () => {
            this.scrollContainerTerms.visible = true;
            this.scrollContainerPrivacy.visible = false;

            this.termsText.setStyle({fill: "#eee"});
            this.privacyText.setStyle({fill: "#777"});

            this.termsText.actived=false;
        })

        setupButtonClick(this.privacyText, () => {
            this.scrollContainerTerms.visible = false;
            this.scrollContainerPrivacy.visible = true;

            this.privacyText.setStyle({fill: "#eee"});
            this.termsText.setStyle({fill: "#777"});

            this.privacyText.actived=false;
        })
    }

    onStartClick(){
        this.cameras.main.fadeOut(500, 0, 0, 0);
        this.cameras.main.once(Phaser.Cameras.Scene2D.Events.FADE_OUT_COMPLETE, (cam, effect) => {
            SceneUtils.startFullscreen(this);
            this.scene.start('Game');
        })
    }

    update(){
        this.game.threeRenderer.render(this.game.threeScene, this.game.threeCamera);
    }

}